export default __webpack_public_path__ + "static/media/image_4.655cc2b4.jpg";